import React, { useState, useEffect, useCallback } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";
import { useTranslation } from "react-i18next";
import HomeLayout from "../../../Layout/HomeLayout";
import DynamicCard from "../../../CustomComponents/DynamicCard";
import { useNavigate } from "react-router";
import LineBreaks, {
  ClimbManageSettingsSidebar,
  retrieveData,
} from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import {
  COVERED_BY_KUDZU_PLUS,
  GET_ALL_SPEND_ALERTS,
  GET_ALLOCATE_FUND_ACCOUNTNAME,
  GET_ALLOCATE_FUND_FREQUENCIES,
  GET_CLIMB_FEATURES,
  GET_COMPLETE_SAVING_GOAL_V2,
  GET_MANAGE_SAVING_GOAL_V2,
  SAVING_CARD_CODE,
  SAVINGS_GOALS,
  SPENDING_ALERT,
  STATUS_SUCCESS_CODE,
} from "../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  GetRequest,
} from "../../../../network/NetworkUtils";
import { appTheme } from "../../../../helpers/utils/Utils";
import CardHeading from "../../../CustomComponents/CardHeading";
import ProgressBar from "../../../CustomComponents/ProgressBar";
import ArrowIcon from '../../../../assets/kudzu-plus-images/arrow_icon_saving_goal.png'
import Lock from '../../../../assets/kudzu-plus-images/securityIcon.png';
import ChevronDownIcon from '../../../../assets/kudzu-plus-images/dropdownArrow.png'
import ChevronUpIcon from '../../../../assets/kudzu-plus-images/up-arrow-plus.png'

const ManageSavingsGoals = () => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [isLoading, setIsLoading] = useState(false);
  const [spendAlertsArray, setspendAlertsArray] = useState(null);
  const [showSubItems, setShowSubItems] = useState(false);
  const [isClimbings, setisClimbings] = useState([]);
  const [isOptIn, setIsOptIn] = useState("");
  const [SpendingAlertCode, setSpendingAlertCode] = useState("");
  const [SpendingCount, setSpendingCount] = useState(0);
  const [manageSavingGoalList, setManageSavingGoalList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const climbFeatures = useSelector((state) => state.climbFeatures);
  const enabledClimbings = climbFeatures?.filter(
    (response) => response.enabled === true
  );

  const isCoveredByKudzuOptedIn = enabledClimbings?.some(
    (item) => item.code === "CoveredByKudzu" && item.optedIn
  );

  const accessToken = useSelector((state) => state.accessToken);
  const isPrimrayKey = cards !== null ? (cards !== null ? cards[0].CardKey : 0) : 0;
  const [isCoveredByKudzuIneligibleSetupSavings, setIsCoveredByKudzuIneligibleSetupSavings,] = useState(false);
  const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);
  const savingsCardExist = cards?.some((item) => item.AccountTypeName === "Savings");
  const savingsWithBalanceOver50 = cards.find(
    (obj) => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
  );
  const issavingsGoalEligible = isClimbings?.find(item => item?.code === SAVINGS_GOALS);
  const isCoveredByKudzuPlusOptedIn = enabledClimbings?.some(item => item.code === COVERED_BY_KUDZU_PLUS && item.optedIn)
  const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)
  const SavingGaolName = useSelector(state => state.savingGoals.Name)
  const [isOptInModalOpen, setIsOptInModalOpen] = useState(false);
  const data = useSelector(state => state.manageSavingData)
  const ManageSavingTotalCount = useSelector(state => state.manageSavingTotalCount)
  const totalAmount = manageSavingGoalList?.reduce((sum, item) => sum + item.amount, 0);
  const formattedAmount = totalAmount ? totalAmount?.toFixed(2) : "0.00";
  const [beforeDecimal, afterDecimal] = formattedAmount?.split('.')
  const [completeSavingGoalList, setCompleteSavingGoalList] = useState([]);
  const [isCompletedGoalsOpen, setIsCompletedGoalsOpen] = useState(false); 

  const toggleCompletedGoals = () => {
    setIsCompletedGoalsOpen(prev => !prev);
  };

  const handleClimbFeatures = async () => {
    if (cards == null || cards == undefined) {
      return;
    }
    setIsLoading(true);
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_CLIMB_FEATURES.replace("{CARD_KEY}", isPrimrayKey);
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      //  debugger;
      const spendingAlertResponse = responseJson.Response.find(
        (obj) => obj.code === SPENDING_ALERT
      );
      if (spendingAlertResponse) {
        const isOptInValue = spendingAlertResponse.optedIn;
        setSpendingAlertCode(spendingAlertResponse.code);
        setIsOptIn(isOptInValue);
        setShowSubItems(isOptInValue);
      } else {
      }
      const enabledClimbings = responseJson.Response.filter(
        (response) => response.enabled === true
      );
      setisClimbings(enabledClimbings);
      setIsLoading(false);
    } else {
      return [];
    }
  };

  //API Call-------------------
  const getAllSpendAlerts = async () => {
    if (isPrimrayKey == null || isPrimrayKey == undefined) {
      return;
    }
    try {
      setIsLoading(true);
      const deviceId = await retrieveData("updatedDeviceId");
      const cardKey = isPrimrayKey;
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const url = GET_ALL_SPEND_ALERTS(cardKey);
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setspendAlertsArray(responseJson.Response);
        console.log(responseJson.Response);
        setSpendingCount(responseJson.Response.length);
        const SPENDSONSCOUNTPAYLOAD = {
          spendAlertCount:
            responseJson.Response.length > 0 ? responseJson.Response.length : 0,
        };
        dispatch({
          type: "SPENDS_ALERT_COUNT",
          payload: SPENDSONSCOUNTPAYLOAD,
        });
        setIsLoading(false);
      } else if (responseJson.Messages) {
        const displayErrorText = responseJson.Messages[0].DisplayText;
        setIsLoading(false);
      }
    } catch (error) { }
  };


  useEffect(() => {
    handleClimbFeatures();
    getAllSpendAlerts();
  }, [showSubItems, isOptIn, SpendingCount]);

  const closeOptInModal = () => {
    setIsOptIn((prev) => !prev);
    setIsOptInModalOpen(false);
  };

  const ManageSettingsbuttonLabels = [
    { label: "SpendSense Alerts", link: "/Climb/ManageSpendAlerts" },
    { label: 'Covered by Kudzu', link: kudzuPlusTrue ? (isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn) ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' : isCoveredByKudzuOptedIn ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' },
    { label: "Savings Habits", link: "/Climb/ManageSavingsHabit" },
    ...(issavingsGoalEligible ? [{ label: 'Savings Goals', link: isSavingsGoalsOptedIn ? '/Climb/SavingGoals/ManageSavingGoal' : '/Climb/ClimbSettings' }] : []),

  ];

  //Saving Goal List API Call
  const GetManageSavingGoalData = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const url = GET_MANAGE_SAVING_GOAL_V2(savingsAccount.CardKey, page);
    try {
      const response = await GetRequest(url, headers);

      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {

        dispatch({ type: 'MANAGE_SAVING_TOTAL_COUNT', payload: { manageSavingTotalCount: responseJson?.Response?.TotalItemsCount } })
        dispatch({ type: 'MANAGE_SAVING_DATA', payload: { manageSavingData: responseJson?.Response?.Items } })
        setManageSavingGoalList(responseJson?.Response?.Items)
      }
    } catch (error) {
      console.log("error", error);
    }
  }

    //Complete Saving Goal List API Call
  const GetCompleteSavingGoalData = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const url = GET_COMPLETE_SAVING_GOAL_V2(savingsAccount.CardKey, page);
    try {
      const response = await GetRequest(url, headers);
 
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
 
        dispatch({ type: 'COMPLETE_SAVING_GOAL_TOTAL_COUNT', payload: { completeSavingGoalTotalCount: responseJson?.Response?.TotalItemsCount } })
        dispatch({ type: 'COMPLETE_SAVING_GOAL_DATA', payload: { completeSavingGoalData: responseJson?.Response?.Items } })
        setCompleteSavingGoalList(responseJson?.Response?.Items)
      }
    } catch (error) {
      console.log("error", error);
    }
  }


  useEffect(() => {
    GetManageSavingGoalData()
    GetCompleteSavingGoalData()
  }, [])

  const hnaldeAddGoal = () => {
    dispatch({ type: "RESET_SAVING_GOALS" })
    dispatch({
      type: "SELECTED_FREQUENCY_VALUE",
      payload: { selectedFrequencyValue: '' },
    });
    dispatch({ type: "RESET_ALLOCATE_FUND" })
    navigate('/Climb/SavingGoals')
  }

  const navigateClicked = (item) => {
    if (item.link == "/Climb/ManageSavingsHabit") {
      if (!savingsCardExist && item.label == "Savings Habits") {
        closeOptInModal();
        setIsCoveredByKudzuIneligibleSetupSavings(true);
      } else if (
        savingsCardExist &&
        savingsWithBalanceOver50 == undefined &&
        item.label != "Savings Habits"
      ) {
        closeOptInModal();
        setIsCoveredByKudzuIneligible(true);
      } else {
        navigate(item.link);
      }
    } else {
      navigate(item.link);
    }
  };

  const handleGoalDataClicked = (selectedItem) => {
    dispatch({ type: "MANAGE_SAVING_GOAL_DETAILS_OBJ", payload: { manageSavingGoalDetailsObj: selectedItem }, });
    navigate('/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails')
    // return null
  }
  

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 1 && !isLoading && hasMore) {
      GetManageSavingGoalData()
    }
  };

  const handleSetSavingGoal = () => {
    dispatch({ type: "RESET_SAVING_GOALS" })
    dispatch({
      type: "SELECTED_FREQUENCY_VALUE",
      payload: { selectedFrequencyValue: '' },
    });
    dispatch({ type: "RESET_ALLOCATE_FUND" })
    navigate('/Climb/SavingGoals')
  }

  const getAccountNames = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const url = GET_ALLOCATE_FUND_ACCOUNTNAME(savingsAccount.CardKey);
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        const arryData = responseJson.Response.Accounts
        const filteredData = arryData?.filter(item => item.AccountName !== SavingGaolName);
        dispatch({ type: 'ACCOUNT_TYPES_DATA', payload: { accountTypes: filteredData } })

        const hasSVGGoal = arryData?.filter(item => item.AccountType === "SVGGoal").length > 2;
        dispatch({ type: 'HAS_SVG_GOAL_ACCOUNT', payload:{ hasSVGGoal : hasSVGGoal} });

      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getFrequency = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_ALLOCATE_FUND_FREQUENCIES;
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        dispatch({ type: "FREQUESCY_DATA", payload: { frequecyData: responseJson.Response } })
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAccountNames();
    getFrequency()
  }, []);


  return (
    <>
      <HomeLayout>

        <ClimbManageSettingsSidebar
          indexBtn={4}
          ManageSettingsbuttonLabels={ManageSettingsbuttonLabels}
          headingMessage={false}
          count={ManageSavingTotalCount ? ManageSavingTotalCount : 0}
          isShow={true}
          navigateClicked={navigateClicked}
        />
        <div
          className="flex flex-col md:w-[860px] sm:w-[464px]
            w-[100%] animate__animated animate__fadeInRight "
        >
          <DynamicCard
            header={false}
            CardRadius={true}
            cardWidth={'100%'}
            HeaderRadius={true}
            footer={true}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={"--cardHeading-bg"}
            HeaderContent={
              <>
                <CardHeading heading={t("manageSavingsGoals")} />
              </>
            }
          >
            {
              manageSavingGoalList && manageSavingGoalList?.length > 0|| completeSavingGoalList && completeSavingGoalList.length > 0 ? (

                <div style={{ pointerEvents: isSavingsGoalsOptedIn ? "auto" : "none", width: "100%" }}>
                  <div
                    className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                      sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
                      text-[var(--text-clrs)] mt-6   mx-auto"
                    style={{ width: manageSavingGoalList?.length > 0 ? "78%" : "85%" }}
                  >
                    <span className="font-hanken-grotesk text-[#94C3E8] uppercase  lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px]  font-[600] tracking-[2px] md:pb-6 pb-5">
                      {t("Savings_Goal_Total")}
                    </span>
                    <div
                      className="flex md:font-[400] sm:font-[400] font-[400]
                        md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  text-[#FFFFFF] font-hanken-grotesk"
                    >
                      <div className="lg:text-[44px] md:text-[38px] sm:text-[23px] text-[38px]">
                        ${beforeDecimal}
                      </div>
                      <div className="lg:text-[43px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">
                        .
                      </div>
                      <div
                        className="lg:text-[30px] md:text-[20px] sm:text-[15px] text-[20px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
                        font-hanken-grotesk"
                      >
                        {afterDecimal}
                      </div>
                    </div>

                    {manageSavingGoalList && manageSavingGoalList?.length > 0 && manageSavingGoalList?.map((item, index) => {
                      const targetAmountFormated = item.amount ? item.amount.toFixed(2) : "0.00";;
                      const [targetAmountBeforeDecimal, targetAmountAfterDecimal] = targetAmountFormated?.split(".");

                      return (
                        <div className={`mt-6 text-[#FFFFFF] font-hanken-groteskhide-scrollbar max-h-[700px] overflow-y-auto ${isSavingsGoalsOptedIn
                          ? "opacity-1"
                          : "opacity-[0.5]"
                          } `} onScroll={handleScroll} >
                          <div className="flex flex-col gap-3 w-full">
                            <div className="flex justify-between w-full cursor-pointer" onClick={() => handleGoalDataClicked(item)}>
                              <div><p className="text-[18px] font-normal">{item.goalName}</p></div>
                              <div className={`${item.isLocked ? 'w-[44px] flex justify-between' : ""}`}>
                                {item.isLocked && (
                                  <img className="relative top-4 w-[17px] h-[22px] mt-[-2px]" src={Lock} key={item.goalName} />
                                )}
                                <img
                                  src={ArrowIcon}
                                  alt="Computer"
                                  className="relative top-4 w-[10px] h-[15px]"
                                />
                              </div>
                            </div>

                            <ProgressBar
                              filledbgColor={"#30BC89"}
                              unfilledBg={"#324261"}
                              progressBarWidth={"100%"}
                              progressBarHeight={"6px"}
                              progress={item.percentage > 100 ? 100 : item.percentage}
                            />

                            <div className="flex justify-between w-full">
                              <p className="font-normal text-[18px] ">{item.percentage}%</p>
                              <p className="font-normal text-[18px]">
                                <div className="flex font-hanken-grotesk">
                                  <div className="">${targetAmountBeforeDecimal}</div>
                                  <div className=" ">.</div>
                                  <div className=" font-hanken-grotesk">
                                    {targetAmountAfterDecimal}
                                  </div>
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    )}
                  </div>
                  {!isCompletedGoalsOpen && <hr className="border-t-2 border-[#4B70B9] mt-16 w-[78%] ml-[11%]" />}
                   
                  {/* COMPLETE SAVING GOAL */}
                  <div className={` ${!isCompletedGoalsOpen ? 'bg-[#2C3449]' : 'bg-[#222737]'} mt-2`}
                    style={{ width: "100%" }}>
                   <div
                       className={`font-serif-pro font-[400] lg:text-[26px] md:text-[24px] sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] text-[var(--text-clrs)] mt-6 mx-auto
                             w-[78%]`}
                           >
                      <div className="flex justify-between items-center cursor-pointer" onClick={toggleCompletedGoals} >
                        <span className="font-hanken-grotesk text-[#ffffff] uppercase mt-10 lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px] font-[600] tracking-[2px] md:pb-6 pb-5">
                          {t("Completed_Goals")}
                        </span>
                        <img
                          src={isCompletedGoalsOpen ? ChevronUpIcon : ChevronDownIcon}
                          alt="Toggle"
                          className="w-[18px] h-[16px]"
                        />
                      </div>

                      {isCompletedGoalsOpen && completeSavingGoalList && completeSavingGoalList?.length > 0 && completeSavingGoalList?.map((item, index) => {
                        const targetAmountFormated = item.amount ? item.amount.toFixed(2) : "0.00";;
                        const [targetAmountBeforeDecimal, targetAmountAfterDecimal] = targetAmountFormated?.split(".");
                        return (
                          <div className={`mt-6 text-[#FFFFFF] font-hanken-groteskhide-scrollbar max-h-[700px] overflow-y-auto ${isSavingsGoalsOptedIn
                            ? "opacity-1"
                            : "opacity-[0.5]"
                            } `} onScroll={handleScroll} >
                            <div className="flex flex-col gap-3 w-full mb-10">
                              <div className="flex justify-between w-full cursor-pointer " onClick={() => handleGoalDataClicked(item)}>
                                <div><p className="text-[18px] font-normal">{item.goalName}</p></div>
                                <div className={`${item.isLocked ? 'w-[44px] flex justify-between' : ""}`}>
                                  {item.isLocked && (
                                    <img className="relative top-4 w-[17px] h-[22px] mt-[-2px]" src={Lock} key={item.goalName} />
                                  )}
                                  <button
                                    className="text-[#A5D4FF] font-hanken-grotesk border-[3px] border-[#A5D4FF] rounded-full px-4  text-[16px] font-[600] hover:bg-[#A5D4FF33] transition duration-200"
                                    onClick={() => handleGoalDataClicked(item)}
                                  >
                                    View Details
                                  </button>
                                </div>
                              </div>

                          <ProgressBar
  filledbgColor={"#30BC89"}
  unfilledBg={"#324261"}
  progressBarWidth={"100%"}
  progressBarHeight={"6px"}
  progress={
    item.percentage === 0
      ? 100
      : item.percentage > 100
        ? 100
        : item.percentage
  }
/>
                              <div className="flex justify-between w-full">
                                <p className="font-hanken-grotesk text-[14px] "> {t("Completed_goal")}</p>
                                <p className="font-normal text-[18px]">
                                  <div className="flex font-hanken-grotesk">
                                    <div className="">${targetAmountBeforeDecimal}</div>
                                    <div className=" ">.</div>
                                    <div className=" font-hanken-grotesk">
                                      {targetAmountAfterDecimal}
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      )}
                    </div>
                  </div>
                  {/* borderGradientManageSaving      border */}
                  <div className="flex justify-center my-32">
                    <button onClick={hnaldeAddGoal}  disabled={manageSavingGoalList?.length === 5} className={`w-[66%] md:h-[50px] sm:h-[60px] h-[50px] md:text-[16px] text-[15px] font-hanken-grotesk
                     px-12 ${manageSavingGoalList?.length < 5  ? "text-[#fffff] borderGradientManageSaving" : "text-[#94C3E8] border-[#779CE5] border-2"}    py-[15px   ${isSavingsGoalsOptedIn
                        ? "opacity-1"
                        : "opacity-[0.5]"
                      }`}>{t('Add_Goal')}</button>
                  </div>
                </div>

              ) : (
                <div >
                  <div
                    className={`${kudzuPlusTrue ? "" : "border-[#94C3E8] border-b-[3px]"
                      } sm:mx-0 mx-4`}
                  ></div>

                  <div className="justify-center flex lg:mt-8 md:mt-6 sm:mx-0 mx-4">
                    <div className="lg:w-[76%] sm:w-[81%] w-full">
                      <>
                        <p
                          className="font-hanken-grotesk font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px]
                                        text-[16px] leading-[24px]  w-[382px] pt-8 text-[var(--climbManage-Spend-p-clr)]"
                        >
                          {t("don't_have_savings_goal")}
                          <span
                            className="text-[var(--climb-payperks-clr)] cursor-pointer"
                            onClick={() => {
                              navigate("/PayPerks");
                            }}
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") navigate("/PayPerks");
                            }}
                          >
                            {t("NavbarPerks")}
                            <span className="text-[#FFFFFF]">.</span>
                          </span>
                        </p>
                      </>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center my-28">
                    <div class="border-[var(--Border-bottom-manageAlerts)] border-b-[2px] border-opacity-[50%] lg:mt-[15rem] md:mt-[14rem] sm:mt-10 mt-12  sm:block hidden w-full"></div>
                    <div className="flex justify-center flex-col items-center md:my-16 sm:my-12 my-16">
                      <div className="lg:w-[72%] sm:w-[81%]  w-full">
                        <button
                          className={`font-hanken-grotesk sm:font-bold leading-[24px]
                                                    sm:leading-[12px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] md:leading-[16px]
                                                     text-[var(--add-External-clr)] font-[600]
                                                    cursor-pointer border-2 px-2 py-4 border-[var(--add-External-border-clr)] w-full 
                                                    ${isSavingsGoalsOptedIn
                              ? "opacity-1"
                              : "opacity-[0.5]"
                            }`}
                          onClick={handleSetSavingGoal}
                          tabIndex={0}
                          onKeyDown={(e) => {
                          }}
                          disabled={!isSavingsGoalsOptedIn}
                        >
                          {t("set_savings_goal")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </DynamicCard>
        </div>
      </HomeLayout>
      {isLoading && <Loader />}
    </>
  );
};

export default withOidcSecure(ManageSavingsGoals);
